/* eslint-disable no-unused-expressions */
/* eslint-disable no-prototype-builtins */
import Vue from 'vue'
import router from '../../router'
import store from '../../store'
import _ from 'lodash'
// import ModalMixin from './modal-mixin'
const modals = {}

const initVueComponentInModals = key => {
  modals[key] = Vue.extend({
    components: {
      Modal: Vue.extend({
        ...modals[key]
      })
    },
    template: '<Modal/>',
    router,
    store
  })
}
for (const key in modals) {
  if (modals.hasOwnProperty(key)) {
    initVueComponentInModals(key)
  }
}

// 注册Modal组件
const registerModal = (name, ModalComponent) => {
  modals[name] = ModalComponent
  initVueComponentInModals(name)
}

const staticModals = {}

const install = (Vue) => {
  // 第一个参数：名称，其它参数：传入init方法的参数
  // 返回一个对象，包含modal引用以及promise对象{ref, promise}
  Vue.prototype.modal = function () {
    let name
    const otherArgs = []
    _.forEach(arguments, arg => {
      if (name) {
        otherArgs.push(arg)
      } else {
        name = arg
      }
    })
    if (!name || !modals[name]) throw new Error('modal invoke error')
    const Component = modals[name]
    const vm = new Component()
    vm.$mount()
    document.body.appendChild(vm.$el)
    const modal = vm.$children[0]
    if (!modal.init || !_.isFunction(modal.init)) {
      document.body.removeChild(vm.$el)
      throw new Error('[init] method of Modal component is needed')
    }
    const promise = modal.init.apply(modal, otherArgs)
    try {
      Vue.prototype.Utils.eventCenter.pub('openModal', { ref: modal, promise, name, data: otherArgs })
      if (promise) {
        promise.then(modalRes => {
          Vue.prototype.Utils.eventCenter.pub('closeModal', { name, data: modalRes })
        })
      }
    } catch (e) {

    }
    if (promise) {
      return { ref: modal, promise }
    } else {
      document.body.removeChild(vm.$el)
      vm.$destroy()
      return null
    }
  }
  Vue.prototype.staticModal = function () {
    if (staticModals && staticModals[arguments[0]]) {
      try {
        Vue.prototype.Utils.eventCenter.pub('reachModal', { name: arguments[0] })
      } catch (e) {

      }
      return staticModals[arguments[0]]
    } else {
      let name
      const otherArgs = []
      _.forEach(arguments, arg => {
        if (name) {
          otherArgs.push(arg)
        } else {
          name = arg
        }
      })
      if (!name || !modals[name]) throw new Error('modal invoke error')
      const Component = modals[name]
      const vm = new Component()
      vm.$mount()
      document.body.appendChild(vm.$el)
      const modal = vm.$children[0]
      if (!modal.init || !_.isFunction(modal.init)) {
        document.body.removeChild(vm.$el)
        throw new Error('[init] method of Modal component is needed')
      }
      modal.isStatic = true
      modal.name = name
      const promise = modal.init.apply(modal, otherArgs)

      try {
        Vue.prototype.Utils.eventCenter.pub('openModal', { ref: modal, promise, name, data: otherArgs })
        if (promise) {
          promise.then(modalRes => {
            Vue.prototype.Utils.eventCenter.pub('closeModal', { name, data: modalRes })
          })
        }
      } catch (e) {

      }

      if (promise) {
        const rst = { ref: modal, promise }
        staticModals[name] = rst
        return rst
      } else {
        document.body.removeChild(vm.$el)
        vm.$destroy()
        return null
      }
    }
  }
}

install(Vue)

export default { registerModal, staticModals }
